/**
 * created by tian ruo jun
 选择栏目及同步发布其他栏目
 *
 */
import React, {Component} from 'react';
import {Icon, Input, Tree, DatePicker, Select, message, Modal, Form, Radio, InputNumber} from 'antd'
import SwitchBounced from "../../components/switchBounced/SwitchBounced"
import '../EditorPublishInformation.css'
import Concurrently from "../concurrently/Concurrently";
import BaseComponent from "../../../../base/BaseComponent";
import CmForm from "../../../../components/CmForm/CmForm";
import moment from 'moment';
import ImgUpload
    from "../../../sysManagement/paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
import {systemBaseEvent} from "../../../../base/baseEvent";

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const {TreeNode} = Tree;
const {Option} = Select;
const publishSettings = {
//栏目信息
    programaKey: 'programaFtitle',//栏目信息数据保存标题key
    programaName: '栏目',//栏目信息标题名称
//当前栏目信息
    currentColumnKey: 'currentColumnFtitle',//当前栏目信息数据保存标题key
    currentColumnName: '当前栏目',//当前栏目信息标题名称
    headlinesPlaceholder: '这是一个栏目名称',//栏目名称的提示
    currentColumnIsRequest: true,//是否必输项，
    currentColumnCheckMessage: '请选择当前栏目',
};

export default class SelectColumn extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            columnDown: true,//页面展开
            publishInformation: {
                mainColumn: {},//当前栏目
                deliveryNews: [],//同步发布栏目
            },
            columnTree: [],// 媒体栏目树
            dynamicParams: props.dynamicParams,//动态参数，调用此组件可将此参数给各个插件
            visibleSetting:false,//栏目设置弹窗
            concurrentColumnItem: {},// 同步发布栏目（当前设置项）
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getColumnTree();
        this.getMainColumn()
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.state.dynamicParams = nextProps.dynamicParams;
        if(nextProps.dynamicParams.contentId !== this.state.dynamicParams.contentId) {
            this.getMainColumn();
        };
        // if(!(this.state.columnTree && this.state.columnTree.length)) {//如果加载过了就不加载了
        //     this.getColumnTree();
        // };
    }

    getData = () => {
        let {publishInformation} = this.state;
        return publishInformation
    };

    setData = ({deliveryNews,mainColumn,callBack}) => {
        this.state.publishInformation.deliveryNews = deliveryNews && deliveryNews.length ? deliveryNews.map(item=>{
            if(!item.key){
                let key='';
                if(item.mediaId||item.bindMediaId) {
                    key += item.bindMediaId||item.mediaId
                }
                if(item.treeId||item.bindTreeId) {
                    key += `-${item.bindTreeId||item.treeId}`
                }
                if(item.contentId||item.bindTreeContentId) {
                    key += `-${item.bindTreeContentId ||item.contentId}`
                }
                return {...item,key}
            } else {
                return item
            }
        }) : [];
        // 稿件回显时，手动触发子栏目回调，但此时不刷权限
        systemBaseEvent.syncPlaybackExec("checkedColumnNodes_noReload",this.state.publishInformation.deliveryNews);
        this.setState({},()=>{if(callBack){
            callBack()
        }});
        if(mainColumn) {
            this.setMainColumn(mainColumn)
        }
    };

    // 获取栏目树
    getColumnTree = () => {
        const {mediaId, contentId} = this.state.dynamicParams;
        this.request({
            url: "/cm-sites-pms/website/getColumnTreeByUserAuth",
            // body: {mediaId:mediaId},// 这里传id的作用只是做排序的，主媒体应该排在树结构最前面，排序功能改为前端做
            callBack: (res) => {
                let columnTree = [];
                if (res) {
                    columnTree = res;
                }
                this.setState({columnTree})
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 回显当前栏目信息
    getMainColumn = () => {
        const {mediaId, contentId, treeId, checkMainColumn} = this.state.dynamicParams;
        if (!mediaId || !contentId || !treeId) {
            return;// checkMainColumn ? message.info('缺少相关id，无法加载当前栏目') : console.log('缺少相关id，无法加载当前栏目')
        };
        this.request({
            url: "/cm-sites-pms/website/getColumnInfo",
            body: {mediaId,contentId,treeId},
            callBack: (res) => {
               
                this.setMainColumn(res);
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 回显主栏目
    setMainColumn = (res) => {
        let mainColumn = {};
        let key='';
        if (res) {
            mainColumn = res;
            if(mainColumn.mediaId) {
                key += mainColumn.mediaId
            }
            if(mainColumn.treeId) {
                key += `-${mainColumn.treeId}`
            }
            if(mainColumn.contentId) {
                key += `-${mainColumn.contentId}`
            }
            mainColumn.key = key;
        }
        this.handleOk(mainColumn);
        // this.state.publishInformation.mainColumn = mainColumn;
        // this.setState({})
    };

    render() {
        return (
            <>
                {/*tab*/}
                {this.renderTab()}
                {/*当前栏目*/}
                {this.renderPresentColumn()}
                {/*同时发布栏目*/}
                {this.renderConcurrentColumn()}
            </>
        )
    }

    renderTab = () => {
        const {publishInformation, columnDown} = this.state;
        return (
            <div style={{display: 'flex',justifyContent: 'space-between',marginTop: '10px',}}>
                <div style={{fontWeight: 'bold'}}>{publishSettings.programaName}</div>
                <div><Icon type={columnDown ? "down" : "up"} onClick={this.arrowTransform}/>
                </div>
            </div>
        )
    };
    // 当前栏目
    renderPresentColumn = () => {
        const {publishInformation, columnDown, columnTree} = this.state;
        let mainNode = this.state.publishInformation.deliveryNews;
        return (
            <div style={{
                display: columnDown ? 'flex' : 'none',
                justifyContent: 'space-between',
                marginTop: '10px',
            }}>
                <div style={{lineHeight: '32px'}}>{publishSettings.currentColumnName}</div>
                <Input style={{fontSize: '12px', width: '135px', height: '32px',}}
                       value={publishInformation.mainColumn.contentName}
                       placeholder={publishSettings.headlinesPlaceholder}
                       onClick={() => {
                           let checkedKeys = this.state.publishInformation.mainColumn.key ?
                               [this.state.publishInformation.mainColumn.key]
                               : []
                           this.switchBounced.show();
                           this.switchBounced.onSetCheckedKeys(checkedKeys, this.state.publishInformation.mainColumn);
                       }}
                />
                <div style={{lineHeight: '32px', cursor: 'pointer'}} onClick={() => {

                    let checkedKeys = this.state.publishInformation.mainColumn.key ?
                        [this.state.publishInformation.mainColumn.key]
                        : [];
                    this.switchBounced.show();
                    this.switchBounced.onSetCheckedKeys(checkedKeys,this.state.publishInformation.mainColumn);
                }}>{publishInformation&&publishInformation.mainColumn&&publishInformation.mainColumn.contentName?'切换':'选择'}
                </div>
                <SwitchBounced
                    ref={(ref)=>this.switchBounced=ref}
                    hideNode={mainNode}
                    handleOk={data => this.handleOk(data)}
                    treeData={columnTree}
                />
            </div>
        )
    };
    setShowTit = (title) => {
        return title
        if (title && title.length > 10) {
            if (title.indexOf('/') > -1) {
                return title.split('/').at(-1)
            }
        }
        return title
    };
    // 同时发布栏目
    renderConcurrentColumn = () => {
        let {publishInformation, columnTree, columnDown} = this.state;
        let {deliveryNews = []} = publishInformation;

        let concurrentColumnLength = deliveryNews && deliveryNews.length || 0;
        let checkedKeys = deliveryNews.length ? deliveryNews.map(item =>item.key) : [];
        let mainNode = this.state.publishInformation.mainColumn;
        return (
            <>
                <div style={{display: columnDown?'flex':'none',justifyContent: 'space-between',marginTop: '10px'}}>
                    <div style={{width: 91,height: 16}}>同时发布到({concurrentColumnLength})</div>
                    <div><Icon style={{lineHeight: '20px'}} type="plus" onClick={()=>{
                        this.concurrently.show();
                        this.concurrently.onSetCheckedKeys(checkedKeys, deliveryNews);
                    }}/></div>
                    <Concurrently
                        ref={(ref)=>this.concurrently=ref}
                        hideNode={mainNode}
                        handleOk={checkedNodes => this.concurrentlyOk(checkedNodes)}
                        treeData={columnTree}
                    ></Concurrently>
                </div>
                <div style={{display:concurrentColumnLength&&columnDown?'block':'none',
                    backgroundColor: '#F6F8FD',
                    marginTop: '10px',
                    padding:'6px 2px 6px 10px',
                    width: 240,
                    background: '#F6F8FD',
                    border: '1px solid #EEF2FB',
                    opacity: 1,
                    borderRadius: '5px',
                }}>
                    {concurrentColumnLength ? deliveryNews.map((item, index) => {
                        let title = this.getColumnTitle(item);
                        let showTit = this.setShowTit(title);
                        return (
                            <div key={item.key}
                                 style={{display: 'flex', justifyContent: 'space-between', height: 'auto', padding: 6}}>
                                    <div onClick={() => {
                                        deliveryNews.forEach(Item => {
                                            if (Item.key === item.key) {
                                                item.deliveryWay = item.deliveryWay === 0 ? 1 : 0
                                            }
                                        });
                                        this.setState({})
                                    }} style={{lineHeight: '20px', cursor: 'pointer'}}>
                                        <Icon style={{color: this.themeBgColor}}
                                              type={item.deliveryWay ? "link" : "file-text"}/>
                                    </div>
                                    <div title={title} style={{
                                        flex: 1,
                                        marginLeft: 4,
                                        width: 120,
                                        overflowWrap: "break-word",
                                        // overflow: 'hidden',
                                        // textOverflow: 'ellipsis',
                                        // whiteSpace: 'nowrap'
                                    }}
                                    >{showTit}</div>
                                    <div style={{marginLeft: 4, display: item.titlePic ? 'block' : 'none'}}>
                                        <Icon type="picture"/>
                                    </div>
                                    <div style={{marginLeft: 4, display: item.wbtop ? 'block' : 'none'}}>
                                        <Icon type="vertical-align-top"/>
                                    </div>
                                    <div>
                                        <div
                                            onClick={() => {
                                                this.showSettingModal(item)
                                            }}
                                            style={{color: this.themeBgColor, cursor: "pointer"}}>设置
                                        </div>
                                        <div
                                            onClick={() => {
                                                this.state.publishInformation.deliveryNews = this.state.publishInformation.deliveryNews.filter(Item=>Item.key!==item.key);
                                                this.setState({},()=>{
                                                    systemBaseEvent.syncPlaybackExec("checkedColumnNodes",this.state.publishInformation.deliveryNews);
                                                })
                                            }}
                                            style={{color: this.themeBgColor, cursor: "pointer"}}>删除
                                        </div>
                                    </div>
                            </div>
                        )
                    }) : ''}
                </div>
                {/*点击设置的弹窗*/}
                {this.renderSettingModal()}
            </>
        )
    };

    getColumnTitle(data) {
        let title = "";
        if(data.mediaName) {
            title += data.mediaName
        }
        // if(data.bindTreeName) {
        //     title += `/${data.bindTreeName}`
        // }
        if(data.contentName) {
            title += `/${data.contentName}`
        }
        return title
    };

    showSettingModal(concurrentColumnItem) {
        this.setState({concurrentColumnItem,visibleSetting:true})
    }

    renderSettingModal = () => {
        let {visibleSetting,concurrentColumnItem} = this.state;
        concurrentColumnItem.wbweight =  concurrentColumnItem.wbweight?concurrentColumnItem.wbweight:10; // 设置默认值10
        concurrentColumnItem.wbfirst =  this.setSelected(concurrentColumnItem.wbfirst); // 设置默认值0
        concurrentColumnItem.wbtop =  this.setSelected(concurrentColumnItem.wbtop); // 设置默认值0
        concurrentColumnItem.wbrecommend =  this.setSelected(concurrentColumnItem.wbrecommend); // 设置默认值0
        let wbfirststartdate = concurrentColumnItem["wbfirststartdate"] ? moment(concurrentColumnItem["wbfirststartdate"]) : null;
        let wbfirstenddate = concurrentColumnItem["wbfirstenddate"] ? moment(concurrentColumnItem["wbfirstenddate"]) : null;
        let wbtopdate = concurrentColumnItem["wbtopdate"] ? moment(concurrentColumnItem["wbtopdate"]) : null;
        let wbgotopdate = concurrentColumnItem["wbgotopdate"] ? moment(concurrentColumnItem["wbgotopdate"]) : null;
        return (
            <Modal
                title={'栏目设置'}
                visible={visibleSetting}
                onCancel={()=>{this.setState({visibleSetting:false})}}
                onOk={this.saveSetting}
                destroyOnClose={true}
                width={610}
            >
                <CmForm>
                    <FormItem
                        label={'当前栏目'}
                        required={false}
                    >
                        <Input
                            disabled={true}
                            value={this.getColumnTitle(concurrentColumnItem)}
                        />
                    </FormItem>
                    <FormItem
                        label={"设置发稿形式"}
                        required={false}
                    >
                        <Radio.Group
                            onChange={e => this.onColumnChange({ deliveryWay: e.target.value*1})}
                            value={concurrentColumnItem.deliveryWay}
                        >
                            <Radio value={1}>链接形式</Radio>
                            <Radio value={0}>正文形式</Radio>
                        </Radio.Group>
                    </FormItem>

                    <FormItem
                        label={"设置置顶"}
                        required={false}
                    >
                        <Radio.Group
                            onChange={e => this.onColumnChange({ wbtop: e.target.value*1})}
                            value={concurrentColumnItem.wbtop}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </Radio.Group>
                    </FormItem>
                    {concurrentColumnItem.wbtop===1?
                        <FormItem
                            label={"置顶持续时间"}
                            required={false}
                        >
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['开始时间', '结束时间']}
                                value={[wbtopdate,wbgotopdate]}
                                onChange={(value, dateString)=>{this.onRangePickerChange({value, dateString, startKey:'wbtopdate',endKey:'wbgotopdate'})}}
                                onOk={(value)=>{this.onRangePickerChange({value, startKey:'wbtopdate',endKey:'wbgotopdate'})}}
                            />
                        </FormItem>:null
                    }

                    <FormItem
                        label={"设置头条"}
                        required={false}
                    >
                        <Radio.Group
                            onChange={e => this.onColumnChange({ wbfirst: e.target.value*1})}
                            value={concurrentColumnItem.wbfirst}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </Radio.Group>
                    </FormItem>
                    {concurrentColumnItem.wbfirst===1?
                        <FormItem
                            label={"头条持续时间"}
                            required={false}
                        >
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['开始时间', '结束时间']}
                                value={[wbfirststartdate,wbfirstenddate]}
                                onChange={(value, dateString)=>{
                                    this.onRangePickerChange({
                                        value, dateString,
                                        startKey:'wbfirststartdate',
                                        endKey:'wbfirstenddate'
                                    })
                                }}
                                onOk={(value)=>{
                                    this.onRangePickerChange({
                                        value,
                                        startKey:'wbfirststartdate',
                                        endKey:'wbfirstenddate'
                                    })
                                }}
                            />
                        </FormItem>:null
                    }

                    <FormItem
                        label={"设置推荐"}
                        required={false}
                    >
                        <Radio.Group
                            onChange={e => this.onColumnChange({ wbrecommend: e.target.value*1})}
                            value={concurrentColumnItem.wbrecommend}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </Radio.Group>
                    </FormItem>
                    {/* <FormItem
                        label={"设置重要性"}
                        required={false}
                    >
                        <InputNumber
                            max={10}
                            min={1}
                            precision={0}
                            parser={val => {
                                let newVal = val.replace(/\D/g, '');
                                if(newVal<1) newVal = 1;
                                if(newVal>10) newVal = 10;
                                return newVal
                            }}
                            value={concurrentColumnItem.wbweight}
                            onChange={value => this.onColumnChange({ wbweight: value})}
                        />
                    </FormItem> */}
                    <FormItem
                        label={'设置标题图'}
                        required={false}
                    >
                        <ImgUpload
                            onChange={titlePic => this.onColumnChange({ titlePic })}
                            defaultUpload={"editColumn"}
                            value={concurrentColumnItem.titlePic}
                        />
                    </FormItem>
                </CmForm>
            </Modal>
        )
    };

    onRangePickerOk({value, startKey, endKey}) {
        console.log('onOk: ', value);
        let startTime = value[0].valueOf();
        let endTime = value[1].valueOf();
        this.state.concurrentColumnItem[startKey] = startTime;
        this.state.concurrentColumnItem[endKey] = endTime;
        this.setState({},()=>{

        })
    };

    onRangePickerChange({value, dateString, startKey, endKey}) {

        let startTime = value[0].valueOf();
        let endTime = value[1].valueOf();
        this.state.concurrentColumnItem[startKey] = startTime;
        this.state.concurrentColumnItem[endKey] = endTime;
        this.setState({},()=>{

        })
    };

    setSelected = (num) => {
        if(num!==1) {
            return 0
        } else {
            return num
        }
    };

    onColumnChange(data) {
        let concurrentColumnItem = {...this.state.concurrentColumnItem,...data};
        this.setState({concurrentColumnItem},()=>{
        })
    }

    saveSetting = () => {
        let {visibleSetting, concurrentColumnItem, publishInformation} = this.state;
        let {deliveryNews} = publishInformation;

        let index = deliveryNews.findIndex(item=>item.key===concurrentColumnItem.key);
        if(index>-1){
            this.state.publishInformation.deliveryNews[index] = concurrentColumnItem
        }
        this.setState({visibleSetting:false},()=>{
            let checkedKeys = deliveryNews.length ? deliveryNews.map(item =>item.key) : [];
            this.concurrently.onSetCheckedKeys(checkedKeys, deliveryNews);
        });
    };

    arrowTransform = () => {
        const {columnDown} = this.state;
        this.setState({
            columnDown: !columnDown,
        })
    };

    /**
     * 判定是否需要重置栏目数据
     * */
    beforeHandleOk = (checkedNodes,call) => {
        let mainColumn = this.state.publishInformation?.mainColumn;
        if(
            mainColumn?.contentId != checkedNodes?.contentId ||
            mainColumn?.treeId != checkedNodes?.treeId ||
            mainColumn?.mediaId != checkedNodes?.mediaId
        ) {
            call(checkedNodes)
        }
    }

    // 主栏目点击确认回调
    handleOk = (newCheckedNodes) => {
        this.beforeHandleOk(newCheckedNodes, (checkedNodes) => {
            if(checkedNodes && checkedNodes.contentId && checkedNodes.mediaId) {
                console.log(1)
                this.request({
                    url: "/cm-sites-pms/website/getColumnSyncList",
                    body: {
                        contentId: checkedNodes.contentId,
                        mediaId: checkedNodes.mediaId
                    },
                    callBack: (res) => {
                        // 赋值给副栏目
                        let upDeliveryNews = this.state.publishInformation.deliveryNews;
                        let oldDeliveryNews = JSON.parse(JSON.stringify(upDeliveryNews))
                        if (res && res.length) {
                            let newDeliveryNews;
                            newDeliveryNews = res.filter(item => !upDeliveryNews.some(child => child.contentId == item.bindTreeContentId));
                            if (newDeliveryNews.length) {
                                newDeliveryNews = newDeliveryNews.map(item=>({
                                    contentId: item.bindTreeContentId,
                                    contentName: item.bindContentName,
                                    mediaId: item.bindMediaId,
                                    mediaName: item.bindMediaName,
                                    treeId: item.bindTreeId,
                                    treeName: item.bindTreeName,
                                    deliveryWay: item.deliveryWay,
                                }));
                                upDeliveryNews = [...upDeliveryNews, ...newDeliveryNews]
                            }
                            this.setData({
                                deliveryNews: upDeliveryNews, mainColumn: false, callBack: () => {
                                    if(!this.beforeConcurrentlyOk(oldDeliveryNews,()=>{
                                        // 主栏目改变回调触发子栏目改变回调，此时只需要执行一次流程重启
                                        systemBaseEvent.syncPlaybackExec("checkedColumnNodes_noReload",this.state.publishInformation.deliveryNews);
                                        systemBaseEvent.syncPlaybackExec("columnChange",checkedNodes);
                                    })){
                                        systemBaseEvent.syncPlaybackExec("columnChange",checkedNodes);
                                    }
                                    this.concurrentlyOk(this.state.publishInformation.deliveryNews)
                                }
                            })
                        } else {
                            systemBaseEvent.syncPlaybackExec("columnChange",checkedNodes);
                        }
                    }
                });
            } else {
                systemBaseEvent.syncPlaybackExec("columnChange",checkedNodes);
            }
            if(checkedNodes && checkedNodes.treeId && checkedNodes.mediaId && checkedNodes.contentId) {
                console.log(2)
                if(this.props.dynamicParams && typeof this.props.dynamicParams.setDynamicParams === "function") {
                    // 重新选择主栏目后，需要重新加载表单模块
                    this.props.dynamicParams.setDynamicParams({
                        mediaId: checkedNodes.mediaId,
                        treeId: checkedNodes.treeId,
                        contentId: checkedNodes.contentId,
                    })
                }
            }
            this.state.publishInformation.mainColumn=checkedNodes;
            this.setState({},()=>{
                console.log(this.state.publishInformation.mainColumn)
            })
        })

    };

    /**
     * 判定是否要重置子栏目列表，并重组子栏目列表
     * */
    beforeConcurrentlyOk = (checkedNodes, call) => {
        let oldCheckedNodes = this.state.publishInformation.deliveryNews;
        let newCheckedNodes = this.filterNodes(oldCheckedNodes, this.state.columnTree);
        let arr = [...newCheckedNodes,...checkedNodes];
        arr = arr.filter((item,index)=>{ // 去重
            return arr.findIndex(Item=>Item.treeId==item.treeId && Item.mediaId==item.mediaId && Item.contentId==item.contentId) === index
        })
        if(arr?.length !== oldCheckedNodes?.length) {
            call(arr)
            return true
        }
        if(!arr.every(item=>oldCheckedNodes.some(Item=>item.treeId==Item.treeId))) {
            call(arr)
            return true
        }
        return false
    }

    /**
     * 找到已选中的栏目节点，不存在于栏目树中的节点（也就这个人没有这个栏目的权限）
     * */
    filterNodes = (checkedNodes, data) => {
        return checkedNodes.filter((checkedNode) => {
            // 检查当前节点是否在树中存在匹配
            const foundNode = this.findNodeByKey(data, checkedNode.key);
            return !foundNode; // 如果树中未找到匹配的节点，则保留该节点
        });
    };

    // 辅助函数：根据key在树中查找节点
    findNodeByKey = (data, key) => {
        for (const item of data) {
            if (item.key === key) {
                return item;
            }
            if (item.subtree && item.subtree.length > 0) {
                const foundNode = this.findNodeByKey(item.subtree, key);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
        return null;
    };

    // 切换审核流
    checkActiviti = () => {
        // 通知父页面，主栏目副栏目等发生了改变
        // 父页面拿到最新的栏目数组，掉接口获取操作权限
        // 如果有权限，重新reload审核流，并传递新的activiticonf数组参数
        // 如果没权限，则情况审核流按钮库
    };


    // 同步发布栏目点击确认回调
    concurrentlyOk = (newCheckedNodes) => {
        this.beforeConcurrentlyOk(newCheckedNodes, (checkedNodes) => {
            let deliveryNews = [];
            if (checkedNodes && checkedNodes.length) {
                deliveryNews = checkedNodes.map(item => ({
                    // 重要性 int
                    "wbweight": 10,
                    // 是否头条 int
                    "wbfirst": 0,
                    // 头条结束时间
                    "wbfirstenddate": null,
                    // 头条开始时间
                    "wbfirststartdate": null,
                    // 是否置顶 int
                    "wbtop": 0,
                    // 置顶开始时间
                    "wbtopdate": null,
                    // 置顶结束时间
                    "wbgotopdate": null,
                    // 是否推荐 int
                    "wbrecommend": 0,
                    // 发稿形式
                    "deliveryWay": 0,
                    // 标题图
                    "titlePic": "",
                    ...item,
                }))
            };
            this.state.publishInformation.deliveryNews = deliveryNews;
            this.setState({}, () => {
                systemBaseEvent.syncPlaybackExec("checkedColumnNodes", deliveryNews);
            })

        })

    };
}
